<div class="app-main__inner">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card filter-card mb-3">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
              <div class="position-relative form-group">
                <label for="fromDate" class="form-label">From Date</label>
                <input type="datetime-local" class="form-control" id="fromDate" name="fromDate" [(ngModel)]="fromDate"
                  Placeholder="Enter From Date" />
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
              <div class="position-relative form-group">
                <label for="toDate" class="form-label">To Date</label>
                <input type="datetime-local" class="form-control" id="toDate" name="toDate" [(ngModel)]="toDate"
                  Placeholder="Enter To Date" />
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
              <div class="position-relative form-group">
                <label for="selectConfig" class="form-label">Select Configuration</label>
                <select name="selectConfig" id="selectConfig" class="form-control" [(ngModel)]="selectedConfig"
                  (ngModelChange)="selectedConfigChanged($event)">
                  <option *ngFor="let conf of configs" [value]="conf.ctName">{{conf.ctName}}</option>
                </select>
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
              <div class="position-relative form-group">
                <label for="selectConfig" class="form-label">Select Device</label>
                <select name="selectConfig" id="selectConfig" class="form-control" [(ngModel)]="selectedDevice">
                  <option *ngFor="let dev of devicesForConfig" [value]="dev">{{dev}}</option>
                </select>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12"
              style="display: flex;flex-direction: row;align-items: center;">
              <button type="button" [appDisableWhile]="isSubmitting" class="btn btn-round btn-primary btn-shadow mx-1"
                title="Submit" (click)="getData()"><i class="fa fa-save"></i> Submit</button>
              <button type="button" class="btn btn-round btn-warning btn-shadow mx-1" title="Reset"><i
                  class="fa fa-sync"></i> Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card card-advance-table" >

        <div class="card-header">
          <h4 class="card-title">Data Table</h4>

        </div>
        <div class="card-body" >
          <!-- <table class="table">
            <thead>
               <tr>
                  <th>1</th>
                  <th>1</th>
                  <th>1</th>
                  <th>1</th>
                  <th>1</th>
               </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
              </tr>
               <tr>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
              </tr>
               <tr>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
              </tr>
               <tr>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
              </tr>
            </tbody>
          </table> -->
          <vio-table *ngIf="showdataTable" [tableConfig]="datatableConfig" [tableData]="datatableData"
            [tableHeader]="datatableHeader"></vio-table>
        </div>
      </div>
    </div>
  </div>
</div>
